import { render, staticRenderFns } from "./TabCredits.vue?vue&type=template&id=7b08cddb&"
import script from "./TabCredits.vue?vue&type=script&lang=js&"
export * from "./TabCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports